import $ from 'jquery';
export class Anchor {
    constructor() {
        this.selector = '.js-anchor';
        this.$siteHeader = $('.site-header');
        if ($(this.selector).length === 0)
            return;
        $(this.selector).each((_, element) => {
            $(element).on("click", (event) => {
                const { target } = $(element).data();
                const $target = $(target);
                if ($target.length === 0)
                    throw new Error("The target element is not exist");
                this.scrollToSection($target);
                event.preventDefault();
            });
        });
    }
    scrollToSection($element) {
        let siteHeaderHeight = 0;
        if (this.$siteHeader) {
            siteHeaderHeight = this.$siteHeader.outerHeight();
        }
        const targetTop = $element.offset().top - siteHeaderHeight;
        window.scrollTo({
            top: targetTop,
            left: 0,
            behavior: 'smooth'
        });
    }
}
